import React, { useState } from "react";
import { Container } from "reactstrap";
import ImageUploader from "../../common/ImageUploader";
import { postServices } from "../../../../../apiServices/apiServices";
import toast from "react-hot-toast";

function AddBannerInner(props) {
  const [selectedImages, setSelectedImages] = useState([]);
  //   const [isImg, setIsImg] = useState("");
  const access_token = sessionStorage.getItem("access-token");

  const handleDrop = async (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    handleImageUpload(files);

    // navigate("/admin/manage_banner/image/editor", {
    //   state: { img: URL.createObjectURL(files[0]) },
    // });
    // const croppedImage = await getCroppedImg(
    //   URL.createObjectURL(files[0]),
    //   croppedAreaPixels,
    //   rotation
    // );

    addApiService(files[0]);
  };

  const handleFileSelect = async (event) => {
    const files = Array.from(event.target.files);
    handleImageUpload(files);
    // setIsImg(event.target.files[0]);

    // navigate("/admin/manage_banner/image/editor", {
    //   state: { img: URL.createObjectURL(event.target.files[0]) },
    // });
    addApiService(files[0]);
  };

  const addApiService = async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await postServices(
        `/api/banner/add_banner`,
        access_token,
        formData
      );
      if (res.responseCode === 200) {
        toast.success("Banner added...");
        props.onClose();
        props.fetchBannerData();
        // navigate("/admin/manage_banner");
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleImageUpload = (files) => {
    // Perform any necessary image upload logic here
    const selected = [...selectedImages];

    for (const file of files) {
      selected.push(URL.createObjectURL(file));
    }

    setSelectedImages(selected);
  };

  const handleRemoveImage = (index) => {
    setSelectedImages((prevImages) => {
      const updatedImages = prevImages.filter((_, i) => i !== index);
      return updatedImages;
    });
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  return (
    <Container className="mx-8 mb-8">
      <ImageUploader
        handleDrop={handleDrop}
        handleDragOver={handleDragOver}
        handleFileSelect={handleFileSelect}
        handleRemoveImage={handleRemoveImage}
        selectedImages={selectedImages}
        multiple={false}
      />
      <div className="flex text-red-600 justify-center text-sm">
        <p className="text-center">Image must be 1920px by 960px.</p>
      </div>
    </Container>
  );
}

export default AddBannerInner;
